export default "__VITE_ASSET__BAXUL92S__"